import { PhoneType } from 'models/PhoneNumberDetails';

import Ticket from 'models/Ticket';

import { usePatientModel } from 'components/Patient/usePatientModel';

export const usePatientMessagingStatus = (ticket: Ticket) => {
  const patient = usePatientModel(ticket.patientId);

  const contactId = ticket.operatorTicket?.patientContactId;
  const contact = contactId ? patient?.getContactById(contactId) : null;

  const isSmsOptedOut = contact ? Boolean(contact.smsOptedOutAt) : Boolean(patient?.smsOptOutDate);

  const phoneType = contact ? contact.phoneType : patient?.phoneType;
  const isLandline = phoneType === PhoneType.landline;

  const hasMessagingConsent = patient?.hasMessagingConsent ?? false;

  return {
    isSmsOptedOut,
    isLandline,
    hasMessagingConsent,
    patient
  };
};
